import Chip, { ChipProps } from '@mui/material/Chip';
import { truncateIfTooLong } from 'src/util/truncate';
import { AvatarNext } from './AvatarNext';
import { OptionalWrapper } from './OptionalWrapper';
import { Link } from './Link';
import { useTheme } from '@mui/material/styles';

export type ChipUserProps = {
  username: string;
  avatarUrl: string;
  href?: string;
} & ChipProps;

export function ChipUser({
  username,
  avatarUrl,
  onDelete = undefined,
  sx,
  href,
  ...propsChip
}: ChipUserProps) {
  const theme = useTheme();
  return (
    <OptionalWrapper
      doWrap={!!href}
      Wrapper={<Link href={!!href ? href : ''}></Link>}
    >
      <Chip
        onDelete={onDelete}
        avatar={<AvatarNext alt={username} src={avatarUrl} />}
        label={truncateIfTooLong(username)}
        variant="outlined"
        color="info"
        sx={{
          '.MuiChip-label': {
            color: '#fff',
          },
          '&:hover': { background: theme.palette.info.vertical },
          cursor: 'pointer',
          ...sx,
        }}
        size="small"
        {...propsChip}
      />
    </OptionalWrapper>
  );
}
